export default __webpack_public_path__ + "static/media/ic-crops-celery.eb36b09d.svg";